import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import recordsOfConsumption from './views/records-of-consumption'
import consumptionInfo from './views/consumption-info'
export default [
  {
    path: RoutePathConstants.RECORDS_OF_CONSUMPTION,
    name: 'recordsOfConsumption',
    component: recordsOfConsumption
  },
  {
    path: RoutePathConstants.CONSUMPTION_INFO,
    name: 'consumptionInfo',
    component: consumptionInfo
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/records-of-consumption/routers.js